import { render, staticRenderFns } from "./BiCompareBoxConsultant.vue?vue&type=template&id=0b210a46&"
import script from "./BiCompareBoxConsultant.vue?vue&type=script&lang=js&"
export * from "./BiCompareBoxConsultant.vue?vue&type=script&lang=js&"
import style0 from "./BiCompareBoxConsultant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports